import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Content = styled.section`
  height: calc(100% - 64px);
  padding: 24px;
  background: ${({ theme }) => theme.palette.background.default};
`;
